import httpClient from "@/plugins/axios";


export const getUserProfile = async () => {
    const response = await httpClient.get('/v1/profile/');
    return response;
}

export const setUserStatus = async (status) => {
    const response = await httpClient.patch('/v1/profile/',
        {
            status
        }
    );
    return response;
}

export const updateProfileImage = async (imageBlob, imageName) => {
    const formData = new FormData();
    formData.append("picture", imageBlob, imageName);

    const response = await httpClient.put(`/v1/profile/image/`, formData);
    return response;
}

export const removeProfileImage = async () => {
    const response = await httpClient.delete(`/v1/profile/image/`);
    return response;
}